import React from "react"

import { Image } from "components/anti/image/image"
import { Button } from "components/anti/buttons/buttons"
import { HeadingLink } from "components/anti/type/type"
import { useScrollAnim } from "src/components/hooks/hooks"
import logoLight from "assets/img/logo-duta-pertiwi-white.svg";


export const ProjectDetailsTenants = ({ data, location, lang, isAmp }) => {
    const [trigger, anim] = useScrollAnim()

    return (
        <>
            {data && (
                <section className="py-main" ref={trigger}>
                    <div className="container">
                        <HeadingLink className="flex-wrap">
                            <h2 className={`mb-4 ${anim(1)}`}>Tenants</h2>
                            <Button variant="link" className={`mr-4 ${anim(2)}`} link={`${location}/tenants`}>
                                {lang === "en" ? "See All" : "Lihat Semua"}
                            </Button>
                        </HeadingLink>
                        <div className="row">
                            {data.map((tenant, i) => {
                                return (
                                    <>
                                        {isAmp ? (
                                            <div className={`col-4 col-md-3 mb-4 ${anim(3 + i)}`} key={i}>
                                                <amp-img
                                                    src={tenant?.tenantsImage?.image.sourceUrl}
                                                    class="bg-light img-fluid"
                                                    alt="tenant"
                                                    width="350"
                                                    height="320"
                                                />
                                            </div>
                                        ) : (
                                            <div className={`col-4 col-lg-2 mb-4 ${anim(3 + i)}`} key={i}>
                                                <Image src={tenant?.tenantsImage?.image.sourceUrl} ratio="r-4-3" className="bg-light img-fluid" alt="tenant" />
                                            </div>
                                        )}
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}